// Отказ открытия дровера, разложенный по причинам.
//
// Причины отличаются не текстом, а тем, ЧТО человеку делать дальше: чанк не
// доехал — повтор осмыслен, глобала reactUI на странице нет — повтор даст ровно
// то же самое, и совет «попробуйте ещё раз» превращается в цикл «жми → алерт →
// жми». Поэтому сообщение выбирается причиной, а не одно на все ветки.

export type TFailureReason =
    'react_ui_missing' | 'drawer_show_threw' | 'drawer_show_rejected';

const MESSAGES: Record<TFailureReason, string> = {
    // Глобала reactUI нет, либо у него нет вызываемого show(): скрипт не
    // загрузился, упал или доехал старой версией. Клик повторять бессмысленно,
    // помогает только перезагрузка страницы.
    react_ui_missing: 'Генератор текста не загрузился. Обновите страницу.',
    // show() бросил синхронно — это сломаны мы, а не сеть, и повтор даст то же.
    drawer_show_threw: 'Не удалось открыть генератор текста. Обновите страницу.',
    // Чанк не доехал: сеть, блокировщик, разъехавшийся после деплоя хеш.
    // Загрузчик после сбоя чистый, следующий клик запросит чанк заново.
    drawer_show_rejected:
        'Не удалось открыть генератор текста. Проверьте соединение и попробуйте ещё раз.',
};

export function messageForFailure(reason: TFailureReason): string {
    return MESSAGES[reason];
}

/**
 * Теги отчёта. Виновники у причин разные, поэтому имя исключения едет отдельным
 * тегом: считать «сколько отказов было чанком» по неиндексируемым extras нельзя.
 */
export function failureTags(
    reason: TFailureReason,
    cause?: unknown
): Record<string, string> {
    const tags: Record<string, string> = { failure_reason: reason };

    if (cause instanceof Error && cause.name) {
        tags.drawer_error = cause.name;
    }

    return tags;
}
